/**
 * M23 — convertit la 1re page d'un PDF (plan d'évacuation, plan d'architecte)
 * en image PNG, DANS LE NAVIGATEUR, avant l'envoi. Le serveur ne reçoit qu'une
 * image : aucun outil de conversion à installer côté serveur, et le plan
 * s'affiche partout pareil.
 *
 * pdf.js n'est chargé QU'AU MOMENT où l'on dépose un PDF (import dynamique) :
 * il ne pèse rien sur le reste de l'application.
 */
export async function pdfVersImage(fichier: File, largeurCible = 2000): Promise<File> {
  const pdfjs = await import('pdfjs-dist');
  pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
  const doc = await pdfjs.getDocument({ data: new Uint8Array(await fichier.arrayBuffer()) }).promise;
  const page = await doc.getPage(1);
  const base = page.getViewport({ scale: 1 });
  // Une largeur confortable pour zoomer sur un plan, bornée pour le poids.
  const viewport = page.getViewport({ scale: Math.min(4, largeurCible / base.width) });
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(viewport.width);
  canvas.height = Math.round(viewport.height);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Conversion impossible sur ce navigateur');
  ctx.fillStyle = '#ffffff';                       // fond blanc : un PDF transparent reste lisible
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  await page.render({ canvasContext: ctx, viewport }).promise;
  const blob = await new Promise<Blob | null>((ok) => canvas.toBlob(ok, 'image/png'));
  if (!blob) throw new Error('Conversion impossible');
  return new File([blob], fichier.name.replace(/\.pdf$/i, '') + '.png', { type: 'image/png' });
}
